import { createSlice } from '@reduxjs/toolkit'

/**
 * Global, cached "is Zyni content assist available for this user" flag so every
 * mounted <ZyniFieldAssist> does not re-hit the engagement bootstrap endpoint.
 * Per-request state (loading, candidate, errors) lives in the component.
 */
export interface EngagementAssistState {
    feature: {
        checked: boolean,
        enabled: boolean,
        loading: boolean,
        // Surfaces enabled for this user (e.g. ["engage"]); a field only renders
        // its Zyni button when its own surface appears here.
        surfaces: string[],
    },
    // "Ask Zyni about this item" (Organizational Intelligence Proof #1), resolved
    // from the same bootstrap call.
    itemInsight: {
        enabled: boolean,
    }
}

const initialState: EngagementAssistState = {
    feature: {
        checked: false,
        enabled: false,
        loading: false,
        surfaces: [],
    },
    itemInsight: {
        enabled: false,
    },
}

export const engagementAssistSlice = createSlice({
    name: 'engagement_assist',
    initialState,
    reducers: {
        assistFeatureLoading: (state) => {
            state.feature.loading = true
        },
        assistFeatureResolved: (state, action) => {
            state.feature.loading = false
            state.feature.checked = true
            state.feature.enabled = action.payload?.enabled === true
            state.feature.surfaces = Array.isArray(action.payload?.surfaces) ? action.payload.surfaces : []
        },
        itemInsightFeatureResolved: (state, action) => {
            state.itemInsight.enabled = action.payload?.enabled === true
        },
    },
})

export const { assistFeatureLoading, assistFeatureResolved, itemInsightFeatureResolved } = engagementAssistSlice.actions
